// extracted by mini-css-extract-plugin
module.exports = {"languageSwitch":"LanguageSwitch_languageSwitch__39HAg","btn":"LanguageSwitch_btn__7_bDd"};